import React, { useContext, useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Stack,
  Spinner,
} from "react-bootstrap";

import { Store, CircleDollarSign, Users, Check, CheckCheck } from "lucide-react";
import "../../../assets/css/admin/NotificationsInAdmin/NotificationsInAdmin.css";
import AdminMasterLayout from "../../../layout/admin/AdminMasterLayout";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import Swal from "sweetalert2";

const NotificationInAdmin = () => {
  const [notifications, setNotifications] = useState([]);
  const { baseUrl, loggedInAdmin } = useContext(AppContext);
  const [icon, setIcon] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("");
  const [read, setRead] = useState(false);
  const [idToUpdateDeleteNotification, setIdToUpdateDeleteNotification] =
    useState("");
  const [addNotificationLoading, setAddNotificationLoading] = useState(false);
  const [loadingEditId, setLoadingEditId] = useState(null);
  const [loadingDeleteId, setLoadingDeleteId] = useState(null);

  // ✅ Mark all as read
  const markAllAsRead = () => {
  setAddNotificationLoading(true);

  const formData = new FormData();

formData.append("tpadmin_id", loggedInAdmin.id);

  axios
    .post(
      `${baseUrl}/admin/notification/markAllAsRead`,
      formData,
      {
        headers: {
          "Content-Type":
            "multipart/form-data",
        },
      }
    )
.then((response) => {
  console.log(response.data);

  setAddNotificationLoading(false);

  viewAllUploadedNotification();

  Swal.fire({
    icon: "success",
    title: "Success",
    text: response.data.message,
  });
})
.catch((error) => {
  console.log(error.response?.data);
  setAddNotificationLoading(false);
});
};
  // ---------------- FETCH Notification ----------------
  const viewAllUploadedNotification = () => {
    const formData = new FormData();
    formData.append("tpadmin_id", loggedInAdmin.id )
    axios
      .post(`${baseUrl}/admin/notification/viewAllUploadedNotification`, formData, {headers : {"Content-Type" : "multipart/form-data"}})
      .then((response) => {
        console.log(response.data);

        
if (response.data.success) {
    setNotifications(response.data.notifications);
}

  setAddNotificationLoading(false);

  // Swal.fire({
  //   icon: "success",
  //   title: "Success",
  //   text:
  //     "All notifications marked as read",
  //     });
      })
      .catch((error) => {
        console.log(error.response?.data);
        setNotifications([]);
      });
  };

  const markSingleAsRead = (id) => {
    console.log("**************notification ki id a rhi ha", id)

    const formData = new FormData();
    formData.append("id", id)
    formData.append("status", "read");
    axios
    .post(`${baseUrl}/admin/notification/markSignleAsRead`, formData, {headers : {"Content-Type" : "multipart/form-data"}})
      .then((response) => {
        console.log(response.data);
        if(response.data.success === true){
      setNotifications((prev) =>
    prev.map((item) =>
        item.id === id
            ? {
                  ...item,
                  status: "read",
              }
            : item
    )
);
          Swal.fire({
            icon : 'success', 
            title : 'Notification status',
            text : response.data.message,
            confirmButtonText : 'okay'
          })
          viewAllUploadedNotification();
        }
      })
      .catch((error) => {
        console.log(error.response?.data);
      });
  }
useEffect(() => {
    if (!loggedInAdmin) return;

    console.log("Logged In Admin:", loggedInAdmin);

    viewAllUploadedNotification();

    const interval = setInterval(() => {
        viewAllUploadedNotification();
    }, 5000);

    return () => clearInterval(interval);

}, [loggedInAdmin]);
 
  //     ...item,
  //     read: true,
  //   }));

  //   setNotifications(updatedNotifications);
  // };

  return (
    <AdminMasterLayout>
      <Container fluid className="py-3 px-lg-4 px-md-3 px-2">
        {/* Header */}
        <Row className="align-items-center mb-3">
          <Col xs={12} md={8}>
            <h3
              className="fw-bold mb-1"
              style={{
                fontSize: "28px",
                color: "#111827",
              }}
            >
              Notifications
            </h3>

            <p
              className="mb-0"
              style={{
                color: "#6B7280",
                fontSize: "14px",
              }}
            >
              System notifications and alerts
            </p>
          </Col>

          <Col
            xs={12}
            md={4}
            className="d-flex justify-content-md-end justify-content-start mt-3 mt-md-0"
          >
            <Button
  onClick={markAllAsRead}
  variant="light"
  className="d-flex align-items-center gap-2 px-3 py-2 border"
>
  {addNotificationLoading ? (
    <Spinner
      animation="border"
      size="sm"
    />
  ) : (
    <>
      <Check size={16} />
      Mark All as Read
    </>
  )}
</Button>
          </Col>
        </Row>

        {/* Notification Card */}
        <Card
          className="border-0 overflow-hidden"
          style={{
            borderRadius: "14px",
            boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
          }}
        >
         {notifications?.map(
  (item, index) => (
    <div
      key={item.id}
      style={{
        borderBottom:
          index !==
          notifications.length - 1
            ? "1px solid #E5E7EB"
            : "none",

        background:
          item.status === "read"
            ? "#fff"
            : "#EEF5FF",

        transition:
          "0.3s ease",
      }}
    >
      <Row className="align-items-center gx-0 px-3 py-3">
        {/* LEFT */}
        <Col xs={9} sm={10}>
          <Stack
            direction="horizontal"
            gap={3}
          >
            {/* ICON */}
            <div
              style={{
                width: "42px",
                height: "42px",
                borderRadius:
                  "12px",
                background:
                  "#FF5A1F",
                display: "flex",
                alignItems:
                  "center",
                justifyContent:
                  "center",
                color: "#fff",
              }}
            >
              {item.icon ===
              "shop" ? (
                <Store size={18} />
              ) : item.icon ===
                "payment" ? (
                <CircleDollarSign size={18} />
              ) : (
                <Users size={18} />
              )}
            </div>

            {/* CONTENT */}
            <div>
              <h6 className="mb-1 fw-semibold">
                {item.title}
              </h6>

              <p className="mb-0 text-muted">
                {
                  item.description
                }
              </p>

              {/* READ / UNREAD */}
       <small
  style={{
    color:
      item.status === "read"
        ? "green"
        : "red",
    fontWeight: "600",
  }}
>
  {item.status === "read"
    ? "Read"
    : "Unread"}
</small>
            </div>
          </Stack>
        </Col>

        {/* RIGHT */}
        <Col
          xs={3}
          sm={2}
          className="d-flex justify-content-end"
        >
          <div className="text-end">
            <p className="mb-1 text-muted">
             {
  new Date(
    item.created_at
  ).toLocaleDateString("en-GB")
}
            </p>

            {/* SINGLE / DOUBLE TICK */}
         {item.status === "read" ? (
    <CheckCheck size={18} />
) : (
    <Check
        style={{ cursor: "pointer" }}
        onClick={() => markSingleAsRead(item.id)}
        size={18}
    />
)}
          </div>
        </Col>
      </Row>
    </div>
  )
)}
          
        </Card>
      </Container>
    </AdminMasterLayout>
  );
};

export default NotificationInAdmin;
